export const eimiCampaign = {
  /** ポイント還元進捗カード（マイページで使う共通コンポーネント用） */
  summaryCard: {
    detailLink: "詳細",
    consumedPointLabel: "現在の消費ポイント",
    pointUnit: "pt",
    gaugeLabel: (args: { point: string | number }) =>
      `あなたの還元ポイントは${args.point}ptです`,
    achievedLabel: "達成！",
    maxReturnPointLabel: (args: { point: string | number }) =>
      `上限${args.point}pt`,
    lotteryGaugeLabel: (args: { count: string | number }) =>
      `あなたが応募できるのは${args.count}口です`,
    lotteryNextCaption: (args: { point: string | number }) =>
      `次の1口まで あと${args.point}pt`,
  },
} as const;
